<template>
  <!-- -->
  <div class="defaultViewStyle bi-board" id="BiBoardDiv">
    <board-background line-color="#3f99fa" stock-color="rgba(63,153,250,.3)" class="background">
      <template #logo>
        <img class="image-log" alt="" src="https://file.srbg-ste.com/common/luqiao_logo.png"/>
      </template>
      <template #info>
        <table-button class="to-home" @click="router.push(`/`)">
          <yq-icon name="iconfont_home" />主页
        </table-button>

        <span class="time">
          <span>{{time}}</span>
          <span v-if="!fullScreen"  @click="fullScreenDisplay"><yq-icon  class="screen-icon" name="quanping"/></span>
          <span v-else @click="fullScreenDisplay"><yq-icon  class="screen-icon" name="fullscreen-exit-line"/></span>
        </span>
      </template>
<!--      <span class="company-name">四川路桥交通工程公司数据看板</span>-->
      <div class="title-wrap">
        <h1>四川路桥交通工程公司</h1>
        <div class="sub">PROJECT SAFETY MANAGEMENT DASHBOARD</div>
        <div class="title-line"></div>
      </div>
    </board-background>
    <div class="info-display">
      <div class="left">
        <div class="card">
          <board-data-card line-color="#3f99fa" label="今日施工汇总" @click="windowOpen(`/project/list`)">
            <board-data-count invalid-color="#666" :data-list="projectAllInfo"/>
          </board-data-card>
        </div>
        <div class="card">
          <board-data-card line-color="#3f99fa" label="工地劳务人员数量" @click="windowOpen(`/laborers/list`)">
            <template #desc>TOP5</template>
            <board-simple-rank font-color="#FFF" :rank-list="workRankList" unit-name="人" @click="router.push(`/`)"/>
          </board-data-card>
        </div>
        <div class="card">
          <board-data-card line-color="#3f99fa" label="工地劳务人员打卡统计" @click="windowOpen(`/laborers/attendance`)">
            <template #desc>TOP10</template>
            <board-simple-rank2 :data-list="workerAttendanceList"/>
          </board-data-card>
        </div>

      </div>
      <div class="center">
        <div class="card">
          <road-site-echart ref="echatMap" :marker-color="['#02495b', '#67C23A']"/>
        </div>
        <div class="card">
          <board-data-card line-color="#3f99fa" label="项目统计">
            <board-e-chart-bar-graph :name-list="['作业班组','工人数量']" :x-names="projectXName" :data-list="projectMemberCount" bar-width="20%"/>
          </board-data-card>
        </div>
      </div>
      <div class="right">
        <div class="card-top">
          <div class="card">
            <board-data-card line-color="#3f99fa" :show-title="false" type="simple">
              <weather-component :lat="locationInfo.lat" :lng="locationInfo.lng"/>
            </board-data-card>
          </div>

          <div class="card">
            <board-data-card line-color="#3f99fa" label="施工点位数" @click="windowOpen(`/laborers/attendance/video`)">
              <template #desc>TOP5</template>
              <div style="height: 100%;text-align: center">
                <board-simple-rank :rank-list="installPointList" />
              </div>
            </board-data-card>
          </div>
          <div class="card">
            <!--            <board-data-card line-color="#3f99fa" label="打开车辆管理" @click="toOutLink(`http://39.105.44.93:9999/gps-web/h5/outside?userId=成都营久科技有限公司&password=854214ee5f420ef21a4d6789dd1ebf3e`)">-->

            <!--            </board-data-card>-->
            <board-data-card class="outer-link" line-color="#3f99fa" :show-title="false" type="simple" @click="toOutLink(`http://39.105.44.93:9999/gps-web/h5/outside?userId=成都营久科技有限公司&password=854214ee5f420ef21a4d6789dd1ebf3e`)">
              <a class="ext-card" id="extVideo" href="javascript:void(0)" >
                <div class="ext-ico"><yq-icon name="element-ui_truck"/></div>
                <div class="ext-title">打开车辆管理</div>
                <div class="ext-desc">工程车辆调度管理 · 车辆定位 · 油耗监管</div>
              </a>
            </board-data-card>

          </div>
          <div class="card">
            <!--          <board-data-card line-color="#3f99fa" label="查看监控视频" @click="toOutLink(`https://183.223.88.3:11443`)">-->

            <!--          </board-data-card>-->
            <board-data-card class="outer-link" line-color="#3f99fa" :show-title="false" type="simple" @click="toOutLink(`https://183.223.88.3:11443`)">
              <a class="ext-card" id="extVideo" href="javascript:void(0)" >
                <div class="ext-ico"><yq-icon name="element-ui_camera"/></div>
                <div class="ext-title">监控视频</div>
                <div class="ext-desc">视频监控平台 · 实时查看各工地现场画面与点位录像</div>
              </a>
            </board-data-card>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>

import {useRoute, useRouter} from "vue-router";
import commonApi from "@/api/commonApi";
import util from '@/util/util';
import TableButton from "@/components/h5/button/TableButton.vue";
import WeatherComponent from "@/components/h5/data/WeatherComponent.vue";
import BoardSimpleRank from "@/components/h5/board/BoardSimpleRank.vue";
import BoardSimpleRank2 from "@/components/h5/board/BoardSimpleRank2.vue";
import BoardSimpleRank3 from "@/components/h5/board/BoardSimpleRank3.vue";
import BoardSimpleRank4 from "@/components/h5/board/BoardSimpleRank4.vue";
import BoardDataCount from "@/components/h5/board/BoardDataCount.vue";
import BoardSimplePieCircle from "@/components/h5/board/BoardSimplePieCircle.vue";
import BoardEChartBarGraph from "@/components/h5/board/BoardEChartBarGraph.vue";
import BoardSimpleOverflow from "@/components/h5/board/BoardSimpleOverflow.vue";
import BoardBackground from "@/components/h5/board/BoardBackground.vue";
import YqIcon from "@/components/YqIcon.vue";
import BoardDataCard from "@/components/h5/board/BoardDataCard.vue";
import RoadHomeSimpleRank from "@/components/h5/board/SimpleRank.vue";
import RoadHomeItemRank from "@/components/h5/board/SimpleRank2.vue";

import RoadHomeWarnRank from "@/views/h5/luqiao/monitor/components/RoadHomeWarnRank.vue";
import RoadSiteEchart from "@/views/h5/luqiao/monitor/components/RoadSiteEchart.vue";
import RoadHomeSimpleRank2 from "@/views/h5/luqiao/monitor/components/RoadHomeSimpleRank2.vue";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "RoadBoard",
  components: {
    RoadHomeSimpleRank2,
    RoadHomeSimpleRank,
    RoadHomeWarnRank,
    RoadHomeItemRank,
    BoardSimpleRank, BoardSimpleRank2, BoardSimpleRank3, BoardSimpleRank4, BoardDataCount, BoardSimplePieCircle, BoardEChartBarGraph, BoardSimpleOverflow,
    WeatherComponent,
    TableButton,
    BoardBackground, YqIcon, BoardDataCard, RoadSiteEchart
  },
  data() {
    return {
      dataDetail: {},
      workRankList: [],// 劳务人员出勤工地排名
      userInfo: {},
      monitorData: {}, // 后台返回的数据中台数据
      workerTypeCountData: [], // 劳务人员类型统计数据
      workerAttendanceList: [], // 劳务人员打卡统计
      deviceVideoList: [], // 视频设备的列表
      taskCount: [], // 工作任务统计数据
      taskAllCount: 0, // 工作任务总数
      machineCount: [], // 机械设备统计数据
      installPointList: [], // 工地点位数统计
      entranceCount: [], // 出入场记录数据统计
      clockInDeviceCount: [], // 打卡设备统计数据
      projectAllInfo: [{itemName: "作业项目", count: 0}, {itemName: "作业班组", count: 0}, {
        itemName: "工人数量",
        count: 0
      },], // 项目信息汇总
      projectMemberCount: [], // 项目成员统计
      projectMemberCount2: [],
      interval: null,
      dateString: "",
      locationInfo: {}, // 坐标信息
      fullScreen: false, // 全屏显示
      time: "",
      projectXName: [], // x轴名称

    };
  },
  created() {
    this.setTime();
  },
  mounted() {
    this.loadMonitorData();
  },
  unmounted() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  methods: {
    setTime() {
      requestAnimationFrame(this.setTime); // 浏览器在下一次动画前，会调用这个回调
      this.time = new Date().format("yyyy-MM-dd hh:mm:ss");
    },
    fullScreenDisplay() {
      let elem = document.querySelector("#BiBoardDiv")
      if (!this.fullScreen) { // 全屏显示
        this.fullScreen = true;

        if (elem.requestFullscreen) {
          elem.requestFullscreen(); // 标准方法
        } else if (elem.mozRequestFullScreen) { /* Firefox */
          elem.mozRequestFullScreen(); // 老版Firefox API
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
          elem.webkitRequestFullscreen(); // Chrome, Safari, Opera API
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
          elem.msRequestFullscreen(); // IE/Edge API
        }
      } else {
        this.fullScreen = false;
        document.exitFullscreen();
      }
    },
    windowOpen(url) {
      this.router.push(url);
    },
    // 打开外部链接
    toOutLink(url) {
      window.open(url, "_blank", "noopener=yes,noreferrer=yes")
    },
    loadMonitorData() {
      util.getUserInfo().then(user => {
        this.userInfo = user;
        if (user.roleType === 1) { // 超级管理员，加载全部信息
          commonApi.luqiaoMonitorAdmin().then(res => {
            this.showData(res); // 显示数据
          }).catch(() => this.router.push("/"))
        } else {
          commonApi.luqiaoMonitorMember().then(res => {
            this.showData(res);// 显示数据
          }).catch((e) => {
            console.log("显示异常", e)
            this.router.push("/")
          })
        }
      })
    },
    // 将后台返回的数据显示到页面
    showData(res) {
      // 如果没有数据，就返回主页
      if (!res || res.siteList === null || res.siteList.length === 0) {
        this.router.push("/");
        return;
      }
      this.monitorData = res;
      this.showSiteList(res.siteList); // 工地坐标显示
      this.workerTypeCount(res.workerTypeCount); // 劳务人员按类型统计
      this.workRankList = this.getBuildingList(res.workerSiteCount || []);// 劳务人员按工地统计
      this.workerAttendanceCount(res.workerAttendanceList); // 劳务人员按打卡统计
      this.deviceVideoList = res.deviceVideoCount; // 视频设备统计，按工地
      this.machineCount = this.getBuildingList(res.machineCount || []); // 机械设备统计
      this.installPointList = this.getBuildingList(res.installPoints || []); // 施工点位数统计
      this.entranceCount = this.getBuildingList(res.entranceCount || []);
      this.clockInDeviceCount = res.clockInDeviceCount;
      this.taskCount = res.taskCount;
      this.projectAllInfo = [{
        itemName: "作业项目",
        count: res.projectAllInfo.statisticCount || 0
      }, {itemName: "作业班组", count: res.projectAllInfo.statisticCount2 || 0}, {
        itemName: "工人数量",
        count: res.projectAllInfo.statisticCount3 || 0
      },]; // 项目信息汇总
      // 组装echarts数据
      let arr1 = [];
      let arr2 = [];
      let x = [];
      for (let i = 0; i < res.projectMemberCount.length; i++) {
        x.push(res.projectMemberCount[i].statisticName);
        arr1.push(res.projectMemberCount[i].statisticCount);
        arr2.push(res.projectMemberCount[i].statisticCount2)
      }
      this.projectXName = x;
      this.projectMemberCount = [arr1, arr2]

      // 统计工作任务总数
      let count = 0;
      for (let i = 0; i < this.taskCount.length; i++) {
        count += this.taskCount[i].statisticCount || 0;
      }
      this.taskAllCount = count;
    },

    // 左侧数据，工地劳务人员打卡统计
    workerAttendanceCount(list) {
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        arr.push({itemName: list[i].statisticName, count: list[i].statisticCount, allCount: list[i].statisticCount3})
      }
      this.workerAttendanceList = arr;
    },
    // 左侧数据，显示劳务人员类型统计
    workerTypeCount(list) {
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        arr.push({name: list[i].statisticName, value: list[i].statisticCount});
      }
      this.workerTypeCountData = arr;
    },
    getBuildingList(list) {
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        arr.push({itemName: list[i].statisticName, count: list[i].statisticCount});
      }
      return arr;
    },
    // 左侧数据，显示工地人员统计
    workerSiteCount(list) {
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        arr.push({buildingName: list[i].statisticName, count: list[i].statisticCount});
      }
      this.workRankList = arr;
    },
    // 中心数据-在地图上显示工地的坐标
    showSiteList(list) {
      // 工地的坐标定位，如果有坐标，就添加到地图
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        if (list[i].lng && list[i].lat) {
          // {name: "工地名称", id: "111", value: "宜金高速01", coord: [103.965819, 30.988301]}
          if (list[i].lng && list[i].lat) {
            arr.push({
              ...list[i],
              coord: [list[i].lng, list[i].lat],
              value: list[i].siteName,
            })
          }
        }
      }
      if (this.$refs.echatMap) {
        this.$refs.echatMap.setMarkerList(arr);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(.board-background){
  .title{
    display: flex;
    align-items: center;
  }
}

.title-wrap{position:absolute;left:50%;transform:translateX(-50%);text-align:center}
.title-wrap h1{font-size:26px;font-weight:800;letter-spacing:4px;
  background:linear-gradient(180deg,#fff,#7fd7ff);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;
  text-shadow:0 0 24px rgba(0,212,255,.25);white-space:nowrap; margin: 0; line-height: 36px}
.title-wrap .sub{font-size:11px;letter-spacing:6px;color:var(--tx3);margin-top:2px;line-height: 15px;}
.title-line{display:flex;align-items:center;gap:8px;margin-top:5px}
.title-line::before,.title-line::after{content:'';height:1px;width:46px;background:linear-gradient(90deg,transparent,rgba(0,212,255,.6));position:absolute;top:50%}
.title-line::before{right:calc(50% + 190px)}.title-line::after{left:calc(50% + 190px);background:linear-gradient(90deg,rgba(0,212,255,.6),transparent)}

/* ============ 外链入口 ============ */
.ext-row{display:grid;grid-template-columns:1fr 1fr;gap:14px}
.ext-card{position:relative;display:flex;flex-direction:column;justify-content:center;gap:6px;border-radius:12px;padding:20px 18px;cursor:pointer;text-decoration:none;
  background:linear-gradient(130deg,rgba(14,32,66,.9),rgba(10,23,51,.55));border:1px solid var(--ec);overflow:hidden;transition:transform .15s,box-shadow .15s;--tx:#e8f4ff; --tx2:#8ba6d4; --tx3:#5c7bb0;}
.ext-card:hover{transform:translateY(-2px);box-shadow:0 8px 26px rgba(0,0,0,.35),0 0 20px var(--ec)}
.ext-card::before{content:'';position:absolute;left:-60%;top:0;bottom:0;width:45%;background:linear-gradient(100deg,transparent,rgba(255,255,255,.06),transparent);transform:skewX(-20deg);transition:left .5s}
.ext-card:hover::before{left:120%}
.ext-ico{width:42px;height:42px;border-radius:10px;background:linear-gradient(135deg,var(--ec),rgba(255,255,255,.05));display:flex;align-items:center;justify-content:center;color:#fff;box-shadow:0 0 16px var(--ec);font-size: 36px;}
.ext-title{font-size:16px;font-weight:700;color:var(--tx);letter-spacing:1px}
.ext-desc{font-size:11px;color:var(--tx3);line-height:1.5}
.ext-go{position:absolute;right:14px;top:14px;font-size:10px;color:var(--ec);border:1px solid var(--ec);border-radius:10px;padding:2px 9px;letter-spacing:1px;opacity:.85}
.ext-card:hover .ext-go{background:var(--ec);color:#06122b}
.ext-badge{position:absolute;right:14px;bottom:14px;font-size:10px;color:var(--tx3);display:flex;align-items:center;gap:5px}
.ext-badge i{width:6px;height:6px;border-radius:50%;background:var(--ec);animation:blink 1.6s infinite}
@keyframes blink{0%,100%{opacity:1}50%{opacity:.3}}

.bi-board {
  background: linear-gradient(to top, #110022, #001133);
  border-radius: 0;
  padding-top: 110px;

  .company-name {
    letter-spacing: 0;
    font-size: 30px;
  }

  .image-log {
    height: 44px;
    margin-left: 30px;
  }

  .time {
    color: #FFF;
    margin-right: 60px;

    .screen-icon {
      margin-left: 10px;
      font-size: 30px;
      vertical-align: middle;
    }
  }

  .info-display {
    display: flex;
    height: 100%;
    justify-content: space-between;

    .left {
      color: #FFF;
      width: 20%;
      height: 100%;
      display: flex;
      flex-direction: column;

      .card:nth-child(1) {
        height: 200px;
      }

      .card:nth-child(2) {
        height: 250px;
        margin: 20px 0;
      }

      .card:nth-child(3) {
        flex: 1;
        height: 50%;
      }

      .card:nth-child(4) {
        height: 250px;
        margin-top: 20px;

        .model-info {
          display: flex;
          margin-bottom: 10px;
          background: rgba(255, 255, 255, .05);
          padding: 10px;
          border-radius: 6px;
          align-items: center;

          .info:nth-child(1) {
            width: 100px;
            font-size: 13px;
            font-weight: 600;
            color: #FFF;
            flex-shrink: 0;
          }

          .info:nth-child(2) {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 13px;
          }

          .info:nth-child(3) {
            width: 120px;
            text-align: right;
            color: #fafafa;
            font-size: 12px;
            flex-shrink: 0;
          }
        }
      }
    }

    .right {
      color: #FFF;
      width: 20%;
      display: flex;
      flex-direction: column;

      .card-top {
        height: 70%;
        flex: 1;
        display: flex;
        flex-direction: column;

        .card:nth-child(1) {
          height: 130px;
          margin-bottom: 20px;
        }
        .card:nth-child(2) {
          height: 30%;
          flex: 1;
        }
        .card:nth-child(3) {
          height: 130px;
          margin: 20px 0;
          :deep(.card-content) {
            > div{
              overflow: hidden;
            }
          }
        }
        .card:nth-child(4) {
          height: 130px;
          :deep(.card-content) {
            > div{
              overflow: hidden;
            }
          }
        }
        :deep(.outer-link){
          .card{
            padding: 0;
          }
        }
      }
      > .card {
        height: 30%;
        margin-top: 20px;
      }
    }

    .center {
      flex: 1;
      color: #FFF;
      margin: 0 20px;
      display: flex;
      flex-direction: column;

      .card:nth-child(1) {
        height: 70%;
        flex: 1;
      }

      .card:nth-child(2) {
        height: 30%;
        margin-top: 20px;
      }
    }
  }
}
.to-home{
  font-size: 14px;
  color: #FFF;
  margin-right: 50px;
  .yq-icon{
    font-size: 20px;
    vertical-align: text-bottom;
    margin-right: 5px;
  }
}
</style>